import './style.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import './i18n';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(<App />);

registerServiceWorker();

